<div class="custom-box1">
  <div class="container">
    <div class="row">
      <div class="col-md-12 py-3">
      
        <!-- <cbic-static-text class="content-info" [textEn]="contentType.toUpperCase()" [html]="true"></cbic-static-text> -->
        <mat-tab-group (selectedTabChange)="tabClick($event)" [selectedIndex]="getSelectedIndex()">
          <mat-tab class="news_media_tabs" label="{{ contentData[0].id }}">
            <ng-template mat-tab-label> {{ contentData[0].titleEn }} </ng-template>
            <div *ngIf="tabindex === 0" class="tab_panel_content tab_panel_content_scroll py-3 custom-scroll-bar">
              <div class="container">
                <div class="row">
                  <div class="" *ngIf="isDataAvailable() == false">
                    <span>{{ newsMediaDataNotfound }}</span>
                  </div>
                  <cbic-view-data
                  *ngIf="contentType === 'citizens-corner' && isDataAvailable() === true"
                  [cbicContentMst]="newsMediaData"
                  [showClose]="false"
                  [isBreadcrumb]="false"
                ></cbic-view-data>
                
                <div class="row" *ngIf="contentType !== 'citizens-corner'">
                  <div class="col-md-3 my-4" *ngFor="let phtoglry of newsMediaData.childContentList">
                    <div class="pe-auto bg-light shadow-sm" *ngFor="let photo of phtoglry.cbicDocMsts"
                      (click)="viewFile(photo)">
                      <img src="content/anotherfile/media/{{ photo.filePathEn }}" type="application/image" width="100%"
                        height="200" />
                      <div [innerHTML]="photo.docTitleEn" #scrollHere1 class="p-1 trucate3lines"
                        data-bs-toggle="tooltip" data-bs-placement="top" title="{{ photo.docTitleEn }}"></div>
                    </div>
                  </div>
                </div>
                </div>
              </div>
            </div>
          </mat-tab>
          <mat-tab label="{{ contentData[3].id }}">
            <ng-template mat-tab-label class="news_media_tabs"> {{ contentData[3].titleEn }} </ng-template>
            <div *ngIf="tabindex === 1"
              class="container tab_panel_content tab_panel_content_scroll py-3 custom-scroll-bar">
              <!-- <span (click)="tabHomeClick(contentData[3].id)" class="utils.getDocumentIcon('link')">
                <cbic-static-text
                  *ngIf="contentType === 'citizens-corner' && isDataAvailable() === true"
                  class="btn-link"
                  [textEn]="'Home'"
                  [html]="false"
                ></cbic-static-text
              ></span> -->
              <div class="row">
                <div class="" *ngIf="isDataAvailable() == false">
                  <span>{{ newsMediaDataNotfound }}</span>
                </div>
                <cbic-view-data *ngIf="contentType === 'citizens-corner' && isDataAvailable() === true"
                  [cbicContentMst]="newsMediaData" [showClose]="false" [isBreadcrumb]="false"></cbic-view-data>
                <div class="row" *ngIf="contentType !== 'citizens-corner'">
                  <div class="col-md-3 my-2 float-start" *ngFor="let videos of newsMediaData.childContentList">
                    <a *ngFor="let video of videos.cbicDocMsts" class="pe-auto"
                      (click)="openmodelPopup(video.filePathEn, video.docType)" value="Load Video">
                      <div class="bg-light shadow-sm">
                        <img src="/content/images/video_thumbnail.jpg" width="100%" />
                        <p class="p-1 trucate3lines" data-bs-toggle="tooltip" data-bs-placement="top"
                          title="{{ video.docTitleEn }}">
                          {{ video.docTitleEn }}
                        </p>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </mat-tab>
          <mat-tab label="{{ contentData[2].id }}">
            <ng-template mat-tab-label class="news_media_tabs"> {{ contentData[2].titleEn }} </ng-template>
            <div *ngIf="tabindex === 2"
              class="container tab_panel_content tab_panel_content_scroll py-3 custom-scroll-bar">
              <div class="row">
                <div class="" *ngIf="isDataAvailable() == false">
                  <span>{{ newsMediaDataNotfound }}</span>
                </div>
                <cbic-view-data
                *ngIf="contentType === 'citizens-corner' && isDataAvailable() === true"
                [cbicContentMst]="newsMediaData"
                [showClose]="false"
                [isBreadcrumb]="false"
              ></cbic-view-data>
              <div class="row" *ngIf="contentType !== 'citizens-corner'">
                <div class="col-md-3 my-2" *ngFor="let audios of newsMediaData.childContentList">
                  <a *ngFor="let audio of audios.cbicDocMsts" class="pe-auto"
                    (click)="openmodelPopup('content/anotherfile/media/' + audio.filePathEn, audio.docType)"
                    value="Load Audio">
                    <div class="bg-light shadow-sm">
                      <img src="/content/images/audio.jpg" width="100%" class="shadow-sm" />
                      <cbic-static-text [textEn]="audio.docTitleEn" [textHi]="audio.docTitleHi"
                        class="trucate3lines p-1" data-bs-toggle="tooltip" data-bs-placement="top"
                        title="{{ audio.docTitleEn }}"></cbic-static-text>
                    </div>
                  </a>
                </div>
              </div>
              </div>
            </div>
          </mat-tab>
          <mat-tab label="{{ contentData[1].id }}">
            <ng-template mat-tab-label class="news_media_tabs"> {{ contentData[1].titleEn }} </ng-template>
            <div *ngIf="tabindex === 3"
              class="container tab_panel_content tab_panel_content_scroll py-3 custom-scroll-bar">
              <!-- <span (click)="tabHomeClick(contentData[1].id)">
                <cbic-static-text
                  *ngIf="contentType === 'citizens-corner' && isDataAvailable() === true"
                  class="btn-link"
                  [textEn]="'Home'"
                  [html]="false"
                ></cbic-static-text
              ></span> -->
              <cbic-news-media-tableview *ngIf="contentType !== 'citizens-corner'" [contentId]="contentData[1].id"
                class="my-2"></cbic-news-media-tableview>
              <cbic-view-data *ngIf="contentType === 'citizens-corner' && isDataAvailable() === true"
                [cbicContentMst]="newsMediaData" [showClose]="false" [isBreadcrumb]="false"></cbic-view-data>
            </div>
          </mat-tab>
        </mat-tab-group>
      </div>
    </div>
  </div>
</div>